
export default function quantity(count, singular, plural) {
  if(count == 0 || count > 1) {
    return plural;
  }

  return singular;
}



/** WEBPACK FOOTER **
 ** ./src/__shared__/quantity.js
 **/